import { render, staticRenderFns } from "./NodeInvocationText.vue?vue&type=template&id=3cfa95f9&scoped=true"
import script from "./NodeInvocationText.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeInvocationText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NodeInvocationText.vue?vue&type=style&index=0&id=3cfa95f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa95f9",
  null
  
)

export default component.exports